import React, { useEffect, useState } from "react";
import { Formik, Form, Field, ErrorMessage } from "formik";
import * as Yup from "yup";
import { Box, Button, IconButton, Tooltip } from "@mui/material";
import HighlightOffIcon from "@mui/icons-material/HighlightOff";
import ControlPointIcon from "@mui/icons-material/ControlPoint";
import ClearOutlinedIcon from "@mui/icons-material/ClearOutlined";
import axios from "axios";
import { useNavigate, useParams } from "react-router-dom";
import { AutoComplete, Input, Tag } from "antd";
import Loading from "../../../Components/Loading/Loading";
import axiosInstance from "../../../Components/axiosInstance/AxiosInstance";
import CustomModal from "../../../Components/Customs/CustomModal";
import { useMessage } from "../../../Components/MessageProvider/MessageProvider";
import { GoPlusCircle } from "react-icons/go";
import YukXatiShablon from "../../../Components/YukXati/YukXatiShablon";
import formatNumberWithSpaces from "../../../Components/NumberToWords/FormatNumber";
import Drivers from "./Drivers";
import { IoIosAdd } from "react-icons/io";

const searchResult = (query) => {
  console.log(query);
  return query.map((el, idx) => {
    return {
      value: `${el.id}.  N:${el.auto_number}:  Shaf:${el.driver_name}:  PNFL:${el.PNFL}:`,
      label: (
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
          }}
        >
          <span>N:{el.auto_number}</span>
          <span>Shaf:{el.driver_name}</span>
          <span>PNFL:{el.PNFL}</span>
        </div>
      ),
    };
  });
};

const CustomerSearchResult = (query) => {
  return query.map((el, idx) => {
    return {
      value: `${el.id}. ${el.name}  INN:${el.INN}  TEL:${el.phone}`,
      label: (
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
          }}
        >
          <span>{el.name}</span>
          <div
            style={{
              display: "flex",
              gap: "10px",
            }}
          >
            <span>INN:{el.INN}</span>
            <span>{el.phone}</span>
          </div>
        </div>
      ),
    };
  });
};

export default function YukXatiAdd() {
  const [loading, setLoading] = React.useState(false);
  const messageApi = useMessage();
  let { id } = useParams();

  let navigate = useNavigate();
  let [data, setData] = useState({
    driver_name: null,
    auto_number: null,
    PNFL: null,
  });
  let [user, setUser] = useState(null);
  let [selected, setSelected] = useState(null);
  let [openModal, setOpenModal] = useState(false);
  let [errorMsg, setErrorMsg] = useState(null);
  let [names, setNames] = useState(false);

  let [products, setProducts] = useState([
    {
      tonna: "",
      from_: "",
      name: "",
      price_qop: "",
    },
  ]);

  const elementRef = React.useRef(null);

  const handleUpload = (values) => {
    setData({
      ...data,
      ticket: values.ticket,
      ticket_date: values.ticket_date,
      comment: values.comment,
      date: values.date,
      status: values.status,
      where: values.where,
      products: [
        ...products.map((el) => {
          return {
            ...el,
          };
        }),
      ],
    });

    setOpenModal(true);
  };

  const getNames = async () => {
    try {
      setLoading(true);

      let [info, user] = await axios.all([
        axiosInstance.get("/api/add-product"),
        axiosInstance.get("/api/customers/" + id),
      ]);

      console.log("info");
      console.log(info);
      console.log("user");
      console.log(user);
      setUser(user.data.data);
      if (info.data.success) {
        setNames(info.data.data);
      }
    } catch (error) {
      // getNames();
      if (error?.response?.data?.error) {
        messageApi.open({
          type: "warning",
          content: error?.response?.data?.message,
        });
      } else {
        messageApi.open({
          type: "warning",
          content: error.message,
        });
      }
      console.log(error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    console.log("add");
    getNames();
  }, []);

  const [options, setOptions] = useState([]);
  const [customerOptions, setCustomerOptions] = useState([]);
  let [isModalOpen, setIsModalOpen] = useState(false);
  let [customerId, setCustomerId] = useState(null);
  // `${data?.given_by?.id}. ${data?.given_by?.name}  INN:${data?.given_by?.INN}  TEL:${data?.given_by?.phone}`
  const [drivers, setDrivers] = useState(null);

  let searchDriver = async (val) => {
    try {
      setLoading(true);

      let { data: driver } = await axiosInstance.get(
        "/api/drivers/search?search=" + val
      );

      if (driver.success) {
        console.log(driver);
        setDrivers(driver.data);
        setOptions(val ? searchResult(driver?.data) : []);
      }
    } catch (error) {
      console.log(error);
      if (error?.response?.data?.error) {
        messageApi.open({
          type: "warning",
          content: error?.response?.data?.message,
        });
      } else {
        messageApi.open({
          type: "warning",
          content: error.message,
        });
      }
      console.log(error);
    } finally {
      setLoading(false);
    }
  };

  const handleAdd = async () => {
    if (loading) return;
    try {
      setLoading(true);
      console.log(data);
      let res = await axiosInstance.post("/api/chiqim", data);
      console.log(res.data);

      if (res.data.success) {
        if (data?.customer_id == id) {
          navigate(0, { replace: true });
        } else {
          navigate("/customers/" + data?.customer_id, { replace: true });
        }
        messageApi.open({
          type: "success",
          content: "Chiqim Qo'shildi :)",
        });
        // console.log(data?.customer_id);
      }
    } catch (error) {
      if (error?.response?.data?.error) {
        messageApi.open({
          type: "warning",
          content: error?.response?.data?.message,
        });
      } else {
        messageApi.open({
          type: "warning",
          content: error.message,
        });
      }
    } finally {
      setLoading(false);
    }
  };

  //   search customer
  const [addOption, setAddOption] = useState("");

  const handleSearch = async (value) => {
    try {
      // setLoadingCustomer(true);

      let { data } = await axiosInstance.get(
        "/api/customers/search?search=" + value
      );
      console.log(data);
      setSelected(data?.data);
      setCustomerOptions(value ? CustomerSearchResult(data?.data) : []);
    } catch (error) {
      if (error?.response?.data?.error) {
        messageApi.open({
          type: "warning",
          content: error?.response?.data?.message,
        });
      } else {
        messageApi.open({
          type: "warning",
          content: error.message,
        });
      }
    } finally {
      // setLoadingCustomer(false);
    }
  };

  const onSelect_auto = (value) => {
    setSelected(value);

    let infos = value.split(":").filter((el, i) => {
      if (i !== 0 && i % 2 !== 0) {
        return el;
      }
    });

    console.log(value);
    setData({
      ...data,
      driver_name: infos[1],
      auto_number: infos[0],
      PNFL: infos[2],
    });
  };

  const onSelect_person = (value) => {
    console.log(value.split(".")[0]);
    console.log(value);

    setData({
      ...data,
      given_by: Number(value.split(".")[0]),
    });
  };

  const onSelect_customer = (value) => {
    console.log(value.split(".")[0]);
    console.log(value);

    setData({
      ...data,
      customer_id: Number(value.split(".")[0]),
    });
  };

  let getUser = async () => {
    try {
      let { data: info } = await axiosInstance.get("/api/customers/" + id);

      console.log("data new");
      console.log(info);
      setCustomerId(
        `${info?.data?.id}. ${info?.data?.name}  INN:${info?.data?.INN}  TEL:${info?.data?.phone}`
      );
      setData({
        ...data,
        customer_id: id,
      });
    } catch (error) {
      console.log(error);
    }
  };
  useEffect(() => {
    getUser();
  }, []);
  return (
    <div className="max-w-[900px] w-[98%] m-auto mb-[20px] ">
      <div className="flex items-center justify-between"></div>
      {loading ? <Loading /> : <></>}
      <CustomModal setOpenModal={setOpenModal} openModal={openModal}>
        <div className="flex flex-row items-start justify-between max-w-[900px] w-[98%] m-auto my-0">
          <button
            className="p-1"
            onClick={() => {
              setOpenModal(false);
            }}
          >
            <ClearOutlinedIcon />
          </button>

          <Button
            variant="solid"
            disabled={loading}
            icon={<GoPlusCircle className="font-[30px]" />}
            onClick={() => {
              if (!loading) {
                handleAdd();
              }
            }}
          >
            Saqlash
          </Button>
        </div>
        {openModal ? <YukXatiShablon data={data} user={user} /> : null}
      </CustomModal>
      <div className="max-w-[900px] w-[100%] font-sans">
        <h2 className="text-[16px] text-center" style={{ textAlign: "center" }}>
          ЙУЛ ВАРАКАСИ{" "}
          <Tag color="error" className="ml-1">
            {" "}
            {user?.status}{" "}
          </Tag>
        </h2>
      </div>

      <div>
        <label htmlFor="driver_name">Kimga</label>
        <AutoComplete
          popupMatchSelectWidth={"100px"}
          style={{
            width: "100%",
          }}
          className="max-w-[900px]"
          options={customerOptions}
          onSelect={onSelect_customer}
          onSearch={handleSearch}
          value={customerId}
          onChange={(val) => {
            setCustomerId(val);
          }}
          size="large"
        >
          <Input.Search
            // loading={loadingCustomer}
            size="large"
            placeholder="Qidirish..."
            enterButton
          />
        </AutoComplete>

        <div className="flex flex-col md:flex-row flex-wrap items-center justify-start gap-[10px] w-[100%]">
          {products.map((el, index) => {
            return (
              <div className="relative bg-[#fff] p-4 shadow my-2 rounded w-[100%]  md:w-[49%]">
                <Tooltip title="Remove this">
                  <span
                    onClick={() => {
                      setProducts([
                        ...products.filter((prod, indx) => {
                          console.log(indx !== index);
                          if (indx != index) return prod;
                          console.log(index);
                          console.log(indx);
                        }),
                      ]);
                    }}
                    className="absolute top-1 right-0 flex flex-row align-center justify-center"
                  >
                    <IconButton color="delete">
                      <HighlightOffIcon />
                    </IconButton>
                  </span>
                </Tooltip>
                <div class="w-[100%]">
                  <label
                    for="options"
                    class="block text-sm font-medium text-gray-700 mb-2"
                  >
                    Dori tanlang
                  </label>
                  <div class="relative">
                    <select
                      id="options"
                      onChange={(e) => {
                        setProducts([
                          ...products.map((itm, i) => {
                            if (i === index) {
                              return {
                                ...itm,
                                name: e.target.value,
                              };
                            }
                            return itm;
                          }),
                        ]);
                      }}
                      value={products[index].name}
                      class="block appearance-none w-full bg-white border border-gray-300 hover:border-gray-500 px-4 py-2 pr-8 rounded shadow leading-tight focus:outline-none focus:shadow-outline"
                    >
                      <option value="">Dori turi</option>
                      {names
                        ? names?.map((el) => {
                            return <option value={el.name}>{el.name}</option>;
                          })
                        : null}
                    </select>
                    <div class="pointer-events-none absolute inset-y-0 right-0 flex items-center px-2 text-gray-700">
                      <svg
                        class="fill-current h-4 w-4"
                        xmlns="http://www.w3.org/2000/svg"
                        viewBox="0 0 20 20"
                      >
                        <path d="M7 10l5 5 5-5H7z" />
                      </svg>
                    </div>
                  </div>
                </div>
                <div className="flex flex-col md:flex-row w-[100%] gap-1 justify-between">
                  <div class=" w-[100%] md:w-[50%]">
                    <label
                      for="input-with-helper-text"
                      class="block text-sm font-medium text-gray-700"
                    >
                      {formatNumberWithSpaces(products[index].tonna)} Tonna (
                      {formatNumberWithSpaces(
                        (products[index].tonna * 1000) / 50
                      )}{" "}
                      - qop)
                    </label>
                    <input
                      value={products[index].tonna}
                      type="number"
                      onChange={(e) => {
                        if (e.target.value === "") {
                          setProducts([
                            ...products.map((itm, i) => {
                              if (i === index) {
                                return {
                                  ...itm,
                                  tonna: e.target.value,
                                };
                              }
                              return itm;
                            }),
                          ]);

                          return;
                        }

                        if (!isNaN(e.target.value)) {
                          setProducts([
                            ...products.map((itm, i) => {
                              if (i === index) {
                                return {
                                  ...itm,
                                  tonna: Number(e.target.value),
                                };
                              }
                              return itm;
                            }),
                          ]);

                          return;
                        }
                      }}
                      id="input-with-helper-text"
                      class="w-[100%] mt-1 block w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm placeholder-gray-400 focus:outline-none focus:ring-blue-500 focus:border-blue-500 sm:text-sm"
                      placeholder="Tonnasi"
                    />
                  </div>

                  <div class="w-[100%] md:w-[50%]">
                    <label
                      for="options"
                      class="block text-sm font-medium text-gray-700 mb-1"
                    >
                      Qayerdan
                    </label>
                    <div class="relative">
                      <select
                        id="options"
                        value={products[index].from_}
                        onChange={(e) => {
                          setProducts([
                            ...products.map((itm, i) => {
                              if (i === index) {
                                return {
                                  ...itm,
                                  from_: e.target.value,
                                };
                              }

                              return itm;
                            }),
                          ]);
                        }}
                        class="block appearance-none w-full bg-white border border-gray-300 hover:border-gray-500 px-4 py-2 pr-8 rounded shadow leading-tight focus:outline-none focus:shadow-outline"
                      >
                        <option value="">Qayerdan</option>
                        <option value="Paxta zavod">Paxta zavod</option>
                        <option value="Ko'mirxona">Ko'mirxona</option>
                        <option value="Vagon">Molxona</option>
                      </select>
                      <div class="pointer-events-none absolute inset-y-0 right-0 flex items-center px-2 text-gray-700">
                        <svg
                          class="fill-current h-4 w-4"
                          xmlns="http://www.w3.org/2000/svg"
                          viewBox="0 0 20 20"
                        >
                          <path d="M7 10l5 5 5-5H7z" />
                        </svg>
                      </div>
                    </div>
                  </div>
                </div>
                <div class=" w-[100%] md:w-[100%]">
                  <label
                    for="input-with-helper-text"
                    class="block text-sm font-medium text-gray-700"
                  >
                    Qop Narxi (
                    {formatNumberWithSpaces(products[index].price_qop)}){" "}
                    {formatNumberWithSpaces(
                      products[index].price_qop * products[index].tonna * 20
                    )}{" "}
                    sum
                  </label>
                  <input
                    type="text"
                    onChange={(e) => {
                      if (e.target.value === "") {
                        setProducts([
                          ...products.map((itm, i) => {
                            if (i === index) {
                              return {
                                ...itm,
                                price_qop: e.target.value,
                              };
                            }
                            return itm;
                          }),
                        ]);

                        return;
                      }

                      if (!isNaN(e.target.value)) {
                        setProducts([
                          ...products.map((itm, i) => {
                            if (i === index) {
                              return {
                                ...itm,
                                price_qop: Number(e.target.value),
                              };
                            }
                            return itm;
                          }),
                        ]);

                        return;
                      }
                    }}
                    value={products[index].price_qop}
                    id="input-with-helper-text"
                    class="w-[100%] mt-1 block w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm placeholder-gray-400 focus:outline-none focus:ring-blue-500 focus:border-blue-500 sm:text-sm"
                    placeholder="Qop Narxi"
                  />
                </div>
              </div>
            );
          })}

          <br />
        </div>

        {/* controllers */}
        <div className="w-[100%] gap-[100px] flex flex-row align-center justify-end">
          <Box className="flex flex-row  align-center justify-between">
            <Tooltip title="Add New Question">
              <span
                onClick={() => {
                  setProducts([
                    ...products,
                    {
                      tonna: "",
                      from_: "",
                      name: "",
                      price_qop: "",
                    },
                  ]);
                }}
                className="flex flex-row align-center justify-center"
              >
                <IconButton color="primary">
                  <ControlPointIcon />
                </IconButton>
              </span>
            </Tooltip>
          </Box>
        </div>

        {/* main form */}
        <div className="relative my-4">
          <label htmlFor="driver_name">Auto raqam</label>{" "}
          <Drivers setIsModalOpen={setIsModalOpen} isModalOpen={isModalOpen} />
          <div className="flex flex-row gap-1">
            <AutoComplete
              popupMatchSelectWidth={"100px"}
              style={{
                width: "100%",
              }}
              className="max-w-[900px]"
              options={options}
              onSelect={onSelect_auto}
              onSearch={searchDriver}
              size="large"
            >
              <Input.Search
                // loading={loadingCustomer}
                size="large"
                placeholder="Qidirish..."
                enterButton
              />
            </AutoComplete>
            <Button
              variant="outlined"
              className="w-[50px] "
              onClick={() => {
                setIsModalOpen(true);
              }}
            >
              <IoIosAdd />
            </Button>
          </div>
        </div>

        <label htmlFor="driver_name">Shafyor ismi</label>
        <Input
          loading={loading}
          size="large"
          placeholder="Auto raqam..."
          enterButton
          disabled={true}
          value={data.driver_name}
          onChange={(e) => {
            setData({
              ...data,
              driver_name: e.target.value,
            });
            // console.log(e.target.value);
          }}
        />
        <label htmlFor="driver_name">Shafyor pinfilli</label>
        <Input
          loading={loading}
          size="large"
          placeholder="Auto raqam..."
          enterButton
          disabled={true}
          value={data.PNFL}
          onChange={(e) => {
            setData({
              ...data,
              PNFL: e.target.value,
            });
            // console.log(e.target.value);
          }}
        />
        <label htmlFor="driver_name">Beribyuborgan shaxs</label>
        <AutoComplete
          popupMatchSelectWidth={"100px"}
          style={{
            width: "100%",
          }}
          className="max-w-[900px]"
          options={customerOptions}
          onSelect={onSelect_person}
          onSearch={handleSearch}
          size="large"
        >
          <Input.Search
            // loading={loadingCustomer}
            size="large"
            placeholder="Qidirish..."
            enterButton
          />
        </AutoComplete>
        {/* main form */}
        <Formik
          initialValues={{
            status: "",
            date: "",
            where: "",
          }}
          validationSchema={Yup.object({
            date: Yup.string().required("Yozish shart"),
            where: Yup.string(),
            status: Yup.string().required("tanlanishi shart"),
          })}
          onSubmit={(values) => {
            if (
              products.every(
                (obj) =>
                  obj?.tonna &&
                  obj?.from_?.trim()?.length &&
                  obj?.name?.trim()?.length
              )
            ) {
              handleUpload(values);
            }
          }}
        >
          <Form>
            {/*where */}
            <label htmlFor="where">Qayerga</label>
            <Field
              className="block w-full pl-3 pr-3 py-2 border border-gray-300 rounded-md shadow-sm placeholder-gray-400 focus:outline-none focus:ring-blue-500 focus:border-blue-500 sm:text-sm"
              name="where"
              type="text"
            />
            <div className="mt-1 text-sm text-red-600">
              <ErrorMessage name="where" />
            </div>
            {/* date */}
            <label htmlFor="date">Sana</label>
            <Field
              className="block w-full pl-3 pr-3 py-2 border border-gray-300 rounded-md shadow-sm placeholder-gray-400 focus:outline-none focus:ring-blue-500 focus:border-blue-500 sm:text-sm"
              name="date"
              type="date"
              // onKeyDown={(e) => {
              //   // handleKeyDown(e, 8);
              //   if (e.key === "F2") {
              //     const currentDate = new Date().toISOString().split("T")[0]; // Get current date in YYYY-MM-DD format
              //     setData({
              //       ...data,
              //       ykx: { ...data.ykx, date: currentDate },
              //     });
              //     console.log("Date set to:", currentDate);
              //   }
              // }}
            />
            <div className="mt-1 text-sm text-red-600">
              <ErrorMessage name="date" />
            </div>
            <label htmlFor="status">status</label>
            <Field
              className="block w-full pl-3 pr-3 py-2 border border-gray-300 rounded-md shadow-sm placeholder-gray-400 focus:outline-none focus:ring-blue-500 focus:border-blue-500 sm:text-sm"
              name="status"
              as="select"
            >
              <option value="">Статуст танланг</option>
              <option value="Насия">Насия</option>
              <option value="Накт">Накт</option>
              <option value="Биржа">Биржа</option>
              <option value="Перечесление">Перечесление</option>
              <option value="Шахобча">Шахобча</option>
            </Field>
            <div className="mt-1 text-sm text-red-600">
              <ErrorMessage name="status" />
            </div>

            {/* comment */}
            <label htmlFor="comment">Izox</label>
            <Field
              className="block w-full pl-3 pr-3 py-2 border border-gray-300 rounded-md shadow-sm placeholder-gray-400 focus:outline-none focus:ring-blue-500 focus:border-blue-500 sm:text-sm"
              name="comment"
              as="textarea"
              rows="4"
            />
            <div className="mt-1 text-sm text-red-600">
              <ErrorMessage name="comment" />
            </div>
            <br />
            <button
              type="submit"
              className="bg-blue-500 hover:bg-blue-700 text-white font-bold py-2 px-4 rounded block w-full"
            >
              Qo'shish
            </button>
          </Form>
        </Formik>
        <br />
      </div>
    </div>
  );
}
